import React from 'react';
import {
  ApprovalRequestStatus,
  usePendingApprovalRequestToMeQuery,
} from '../../../__generated__/graphql';
import ServerError from '../../../../../components/ServerError';
import { mapApprovalRequests } from '../ApprovalRequestsTable/mappings';
import { ApprovalRequestsTable } from '../ApprovalRequestsTable/ApprovalRequestsTable';

export const PendingApprovalRequests: React.FC = () => {
  const { data, loading, error } = usePendingApprovalRequestToMeQuery();

  if (error) {
    return <ServerError />;
  }
  const requests = mapApprovalRequests(data?.me.approvalRequests ?? []).filter(
    (request) => request.approvalStatus === ApprovalRequestStatus.Pending,
  );

  return <ApprovalRequestsTable requests={requests} loading={loading} />;
};
